import { render, staticRenderFns } from "./v-card-group.vue?vue&type=template&id=4ab163ba&scoped=true&"
import script from "./v-card-group.vue?vue&type=script&lang=js&"
export * from "./v-card-group.vue?vue&type=script&lang=js&"
import style0 from "./v-card-group.vue?vue&type=style&index=0&id=4ab163ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab163ba",
  null
  
)

export default component.exports